import { HelperResult, SessionTerms } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

interface SessionTermsCreationValues {
  duration: string;
  pace: string;
  sessionsPerRecurrence: number;
}

const { useGet: useSessionTerms, useUpdate: useUpdateSessionTerms } = getCRUDHooks({
  entityName: 'sessionTerms',
  get: ({ userId }: { userId: number }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).sessionTerms.find(),
  update: (
    values: SessionTermsCreationValues,
    { userId }: { userId: number }
  ): HelperResult<SessionTerms> =>
    clientApi
      .getOCClient()
      .createPutRequest('/users/:id/session-terms')
      .setRouteParam('id', userId)
      .setRawBody(values)
      .execute(),
});

// eslint-disable-next-line import/prefer-default-export
export { useSessionTerms, useUpdateSessionTerms };
